import React from 'react';
import { FormField } from '@/components/custom/erp';
import { Label } from '@/components/ui/label';
import { FormMode } from '@/types/form';

interface FormDialogProps {
  formMode: FormMode;
}

const FormDialog: React.FC<FormDialogProps> = ({ formMode }) => {
  const isViewMode = formMode === 'view';

  return (
    <div className='space-y-4 p-4'>
      <div className='flex items-center'>
        <Label className='mt-2 min-w-40'>Mã tính chất thuế</Label>
        <FormField className='w-40' name='ma_tc_thue' disabled={formMode === 'view' || formMode === 'edit'} />
      </div>

      <div className='flex items-center'>
        <Label className='mt-2 min-w-40'>Tên tính chất</Label>
        <div className='flex-1'>
          <FormField name='ten_tc_thue' className='w-full' disabled={isViewMode} />
        </div>
      </div>

      <div className='flex items-center'>
        <Label className='mt-2 min-w-40'>Tên khác</Label>
        <div className='flex-1'>
          <FormField name='ten_tc_thue2' disabled={isViewMode} />
        </div>
      </div>

      <div className='flex items-center'>
        <Label htmlFor='status' className='mt-2 min-w-40'>
          Trạng thái
        </Label>
        <FormField
          id='status'
          type='select'
          name='status'
          className='w-full'
          disabled={isViewMode}
          options={[
            { value: '1', label: '1. Còn sử dụng' },
            { value: '0', label: '0. Không sử dụng' }
          ]}
        />
      </div>
    </div>
  );
};

export default FormDialog;
